import { useState, useEffect, useCallback, useRef } from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dropdown,
  Button,
  Spinner,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import { getTripCostViewApi, deleteTripsApi } from "./trip-cost-api";
import locationIcon from "../../assets/svg/location_ic.svg";
import moreIcon from "../../assets/svg/more_ic.svg";

import DeleteModal from "../common/deleteModel";
import dateIc from "../../assets/svg/date_ic.svg";

import tripIcon from "../../assets/svg/trip_view_ic.svg";
import milestoneIcon from "../../assets/svg/flag_ic.svg";
import distanceIcon from "../../assets/png/estimated_km_so.png";
import timestampIcon from "../../assets/svg/time_ic.svg";
import truckIcon from "../../assets/svg/truck_ic.svg";

import totalAmtIc from "../../assets/svg/rupee.svg";

import Sidebar from "../common/Sidebar";
import fuelCostIc from "../../assets/svg/fuel-cost-ic.svg";
import fastagIc from "../../assets/svg/fastag-ic.svg";
import otherCostIc from "../../assets/svg/other-cost.svg";
import attachment from "../../assets/png/attachment.png";
import downloadIc from "../../assets/svg/download_Ics.svg";
import { Navbar } from "../common/Navbar";
import { useGlobal } from "../../GlobalContext";

export const TripCostView = () => {
  const { rolePermissionList, userType } = useGlobal();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const [viewStopDetails, setViewStopDetails] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Fuel Cost");

  useEffect(() => {
    if (id != null) {
      getTripCostView(id);
    }
  }, [id]);
  function checkPermission(permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === "Trip cost" &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }

  const getTripCostView = async (id) => {
    try {
      const response = await getTripCostViewApi(id);

      if (response.data.success === true) {
        setViewStopDetails(response.data.trip_cost ?? {});
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const deleteVendor = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteTripsApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        navigate(-1);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };
  return (
    <>
      <DeleteModal
        title={"trip cost"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false); // close modal
          setDeleteId(null); // reset selected ID
        }}
        onDelete={deleteVendor}
      />
      <div className="d-flex ">
        <Sidebar currentfile="Trip Cost" />
        <div
          className="rounded-4 flex-grow-1  "
          style={{ width: "calc(100vw - 80px)" }}
        >
          <Navbar pageTitle="Trip Cost" />
          <div
            className="p-2 scroll-hidden"
            style={{ height: "calc(100vh - 56px)", background: "#F5F7FA" }}
          >
            <div
              className="py-2 bg-white d-flex align-items-center justify-content-between"
              style={{
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              }}
            >
              <div className="d-flex align-items-center justify-content-start">
                <div
                  className="ms-2 d-flex align-items-center justify-content-center  rounded-5 bg-white"
                  style={{
                    width: "36px",
                    height: "36px",
                    border: "1px solid #EBEBEB",
                  }}
                >
                  <MoveLeft
                    className="cursor-pointer"
                    onClick={() => {
                      navigate(-1);
                    }}
                  />
                </div>

                <div
                  className="ms-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "16px",
                    background: "#DFE8FF",
                    color: "#3469E7",
                  }}
                >
                  <img src={tripIcon} alt="tripIcon" />
                </div>
                <div className="ms-2 d-flex flex-column align-items-start justify-content-center gap-1">
                  <div className="fs-20 fw-600 textFontColor">
                    {viewStopDetails.trip_code ?? ""}
                  </div>
                  <div className="d-flex align-items-center justify-content-start">
                    <img src={locationIcon} alt="location" />
                    <span
                      className="ms-2 fs-13 fw-400 "
                      style={{ color: "#A2A7AE" }}
                    >
                      {viewStopDetails.location_name ?? ""}
                    </span>
                    <div
                      className="mx-2"
                      style={{
                        width: "5px",
                        height: "5px",
                        borderRadius: "100px",
                        background: "#D9D9D9",
                      }}
                    ></div>
                    <div
                      className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1"
                      style={{ background: "#EDF2FF", color: "#3469E7" }}
                    >
                      <span className="fs-12 fw-500">
                        #{viewStopDetails.mile_stone ?? ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-start me-2">
                {/* <Dropdown>
                  <Dropdown.Toggle
                    bsPrefix="custom-toggle"
                    variant="light"
                    id="dropdown-sort"
                    className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                    style={{
                      padding: "6px 12px",
                    }}
                  >
                    <span className="d-flex align-items-center px-1 gap-2">
                      <span
                        className="backgroundYellow"
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "3px",
                          display: "inline-block",
                        }}
                      ></span>

                      <span className="dropdown-text textcolor fs-13 fw-500">
                        {viewStopDetails.status ?? "-"}
                      </span>

             
                    </span>
                  </Dropdown.Toggle>
                </Dropdown> */}

                <div className="ms-2">
                  {(checkPermission("edit_permission") ||
                    checkPermission("delete_permission")) && (
                    <Dropdown>
                      <Dropdown.Toggle
                        bsPrefix="custom-toggle"
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                        style={{
                          width: "36px",
                          height: "36px",
                          border: "1px solid #EBEBEB",
                        }}
                      >
                        <span className="d-flex align-items-center px-1 gap-2">
                          <img src={moreIcon} alt="more" />
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {checkPermission("edit_permission") && (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              navigate("/cost/create", {
                                state: { id: id },
                              });
                            }}
                          >
                            Edit
                          </Dropdown.Item>
                        )}
                        {checkPermission("delete_permission") && (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              setDeleteId(id);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </div>
              </div>
            </div>

            <>
              <div className="row d-flex align-items-stretch">
                <div className="col-12 col-lg-6 mt-2">
                  <div className="bg-white rounded-4 p-3 d-flex flex-column align-items-start justify-content-start">
                    <div className="fs-16 fw-600 textFontColor">
                      Trip details
                    </div>

                    <div className="mt-3 d-flex align-items-center justify-content-start">
                      <div
                        style={{ width: "200px" }}
                        className="d-flex align-items-center justify-content-start"
                      >
                        <img src={milestoneIcon} alt="location" />
                        <span className="ms-2 fs-13 fw-500 cardTextGrey">
                          Milestone group
                        </span>
                      </div>
                      <div className="fs-13 fw-500 textFontColor">
                        {viewStopDetails.mile_stone ?? ""}
                      </div>
                    </div>

                    <div className="mt-3 d-flex align-items-center justify-content-start">
                      <div
                        style={{ width: "200px" }}
                        className="d-flex align-items-center justify-content-start"
                      >
                        <img src={dateIc} alt="date" />
                        <span className="ms-2 fs-13 fw-500 cardTextGrey">
                          Actual delivery date
                        </span>
                      </div>
                      <div className="fs-13 fw-500 textFontColor">
                        {viewStopDetails.act_date ?? ""}
                      </div>
                    </div>

                    <div className="mt-3 d-flex align-items-center justify-content-start">
                      <div
                        style={{ width: "200px" }}
                        className="d-flex align-items-center justify-content-start"
                      >
                        <img src={distanceIcon} alt="date" />
                        <span className="ms-2 fs-13 fw-500 cardTextGrey">
                          Estimated KM
                        </span>
                      </div>
                      <div className="fs-13 fw-500 textFontColor">
                        {viewStopDetails.est_km ?? ""}
                      </div>
                    </div>

                    <div className="mt-3 d-flex align-items-center justify-content-start">
                      <div
                        style={{ width: "200px" }}
                        className="d-flex align-items-center justify-content-start"
                      >
                        <img src={distanceIcon} alt="date" />
                        <span className="ms-2 fs-13 fw-500 cardTextGrey">
                          Actual KM
                        </span>
                      </div>
                      <div className="fs-13 fw-500 textFontColor">
                        {viewStopDetails.act_km ?? ""}
                      </div>
                    </div>

                    <div className="mt-3 d-flex align-items-center justify-content-start">
                      <div
                        style={{ width: "200px" }}
                        className="d-flex align-items-center justify-content-start"
                      >
                        <img src={timestampIcon} alt="date" />
                        <span className="ms-2 fs-13 fw-500 cardTextGrey">
                          Last tracking on
                        </span>
                      </div>
                      <div className="fs-13 fw-500 textFontColor">
                        {viewStopDetails.update_date ?? ""} {" - "}
                        {viewStopDetails.update_time ?? ""}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="h-100 col-12 col-lg-6 mt-2">
                  <div className="h-100 bg-white rounded-4 p-3 d-flex flex-column align-items-start justify-content-start">
                    <div className="fs-16 fw-600 textFontColor">
                      Vehicle details
                    </div>
                    <div className="mt-2 w-100 row d-flex align-items-stretch">
                      <div className="col-6">
                        <div
                          className="h-100 rounded-3 p-3 d-flex flex-column align-items-center justify-content-center"
                          style={{ background: "#F0F5FF" }}
                        >
                          <div
                            style={{
                              width: "64px",
                              height: "64px",
                              borderRadius: "100px",
                            }}
                          >
                            <img
                              src={viewStopDetails.vehicle_image ?? truckIcon}
                              alt="vehicle"
                              style={{ width: "64px", height: "64px" }}
                            />
                          </div>
                          <div
                            className="fs-20 fw-700"
                            style={{ color: "#28303F" }}
                          >
                            {viewStopDetails.license_plate ?? ""}
                          </div>
                          <div
                            className="fs-13 fw-500"
                            style={{ color: "#3469E7" }}
                          >
                            {viewStopDetails.vehicle_name ?? ""}
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div
                          className="rounded-3 px-2 py-3"
                          style={{ border: "1px solid #EBEBEB" }}
                        >
                          <div
                            className="fs-11 fw-500"
                            style={{ color: "#626F86", textAlign: "start" }}
                          >
                            VEHICLE IDENTIFICATION NUMBER
                          </div>
                          <div
                            className="fs-14 fw-500"
                            style={{ color: "#172B4D", textAlign: "start" }}
                          >
                            {viewStopDetails.vin ?? ""}
                          </div>
                        </div>

                        <div
                          className="mt-2 rounded-3 px-2 py-3"
                          style={{ border: "1px solid #EBEBEB" }}
                        >
                          <div
                            className="fs-11 fw-500"
                            style={{ color: "#626F86", textAlign: "start" }}
                          >
                            VENDOR
                          </div>
                          <div
                            className="fs-14 fw-500"
                            style={{ color: "#172B4D", textAlign: "start" }}
                          >
                            {viewStopDetails.vendor_name ?? ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-3 d-flex align-items-center justify-content-start gap-2">
                <div
                  className="col-6 col-md-3  rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#FFFFFF" }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "#FF4444",
                      borderRadius: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img src={totalAmtIc} alt="total cost" />
                  </div>
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Total Cost
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {viewStopDetails.total_cost ?? ""}
                    </div>
                  </div>
                </div>
                <div
                  className="col-6 col-md-3 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#FFFFFF" }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "#454CF2",
                      borderRadius: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img src={fuelCostIc} alt="fuelCostIc" />
                  </div>
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Fuel Cost
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {viewStopDetails.fual_total ?? ""}
                    </div>
                  </div>
                </div>

                <div
                  className="col-6 col-md-3 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#FFFFFF" }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "#2C8C53",
                      borderRadius: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img src={fastagIc} alt="fastagIc" />
                  </div>
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Fastag Cost
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {viewStopDetails.fast_tag_total ?? ""}
                    </div>
                  </div>
                </div>

                <div
                  className="col-6 col-md-3  rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#FFFFFF" }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "#FDCA01",
                      borderRadius: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img src={otherCostIc} alt="otherCostIc" />
                  </div>
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Other Cost
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {viewStopDetails.other_total ?? ""}
                    </div>
                  </div>
                </div>
              </div>
              <div className="m-2 bg-white rounded-4 p-3">
                <div className="row">
                  <div className="col-12 ">
                    <div className="row">
                      <div className="w-100 mb-1  d-flex align-items-center justify-content-start gap-2">
                        <div
                          className={`d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                            selectedTab === "Fuel Cost"
                              ? "fw-500 active-bottom-bar "
                              : " fw-400"
                          } `}
                          style={{
                            height: "32px",
                            width: "110px",
                            color:
                              selectedTab === "Fuel Cost"
                                ? "#FFFFFF"
                                : "#172B4D",
                            background:
                              selectedTab === "Fuel Cost"
                                ? "#3469E7"
                                : "#F5F5F5",
                          }}
                          onClick={() => {
                            setSelectedTab("Fuel Cost");
                          }}
                        >
                          Fuel Cost
                        </div>
                        <div
                          className={`d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                            selectedTab === "Fastag Cost"
                              ? "fw-500 active-bottom-bar "
                              : " fw-400"
                          } `}
                          style={{
                            height: "32px",
                            minWidth: "110px",
                            color:
                              selectedTab === "Fastag Cost"
                                ? "#FFFFFF"
                                : "#172B4D",
                            background:
                              selectedTab === "Fastag Cost"
                                ? "#3469E7"
                                : "#F5F5F5",
                          }}
                          onClick={() => {
                            setSelectedTab("Fastag Cost");
                          }}
                        >
                          Fastag Cost
                        </div>

                        <div
                          className={`d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                            selectedTab === "Other Cost"
                              ? "fw-500 active-bottom-bar "
                              : " fw-400"
                          } `}
                          style={{
                            height: "32px",
                            minWidth: "110px",
                            color:
                              selectedTab === "Other Cost"
                                ? "#FFFFFF"
                                : "#172B4D",
                            background:
                              selectedTab === "Other Cost"
                                ? "#3469E7"
                                : "#F5F5F5",
                          }}
                          onClick={() => {
                            setSelectedTab("Other Cost");
                          }}
                        >
                          Other Cost
                        </div>
                      </div>

                      {selectedTab === "Fuel Cost" && (
                        <>
                          <div style={{ overflowY: "visible" }}>
                            <div className="mt-2 sticky-table-wrapper ">
                              <table
                                className="stop-table"
                                border="1"
                                cellPadding="10"
                                style={{
                                  borderCollapse: "collapse",
                                  width: "100%",
                                  border: "1px solid #EBEBEB",
                                }}
                              >
                                <thead
                                  style={{
                                    height: "48px",
                                    /*  backgroundColor: "#F2F2F2", // ✅ Green background */
                                    color: "#8790A1", // ✅ White text
                                    fontSize: "11px", // ✅ Font size
                                    fontWeight: "400",
                                    textAlign: "left",
                                  }}
                                >
                                  <tr>
                                    <th className="ps-2">FUEL STATION</th>
                                    <th className="ps-2">LOCATION</th>
                                    <th className="ps-2">QUANTITY</th>
                                    <th className="ps-2">PRICE PER LITER</th>
                                    <th className="ps-2">TOTAL PRICE</th>
                                    <th className="ps-2"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {viewStopDetails.fual_cost?.map(
                                    (row, index1) => (
                                      <tr
                                        key={row.id}
                                        style={{
                                          height: "60px",
                                          position: "relative",
                                          overflow: "visible",
                                        }}
                                      >
                                        <td
                                          className="px-2 py-1"
                                          style={{
                                            position: "relative",
                                            overflow: "visible",
                                          }}
                                        >
                                          <div
                                            className="pe-3 py-1 fs-14 fw-400 textFontColor"
                                            style={{ width: "200px" }}
                                          >
                                            {row.fuelbank ?? ""}
                                          </div>
                                        </td>
                                        <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                          {row.location ?? ""}
                                        </td>

                                        <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                          {row.quentity ?? ""}
                                        </td>
                                        <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                          {row.unit_price ?? ""}
                                        </td>
                                        <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                          {row.totalprice ?? ""}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}

                      {selectedTab === "Fastag Cost" && (
                        <>
                          <div style={{ overflowY: "visible" }}>
                            <div className="mt-2 sticky-table-wrapper ">
                              <table
                                className="stop-table"
                                border="1"
                                cellPadding="10"
                                style={{
                                  borderCollapse: "collapse",
                                  width: "100%",
                                  border: "1px solid #EBEBEB",
                                }}
                              >
                                <thead
                                  style={{
                                    height: "48px",
                                    /*  backgroundColor: "#F2F2F2", // ✅ Green background */
                                    color: "#8790A1", // ✅ White text
                                    fontSize: "11px", // ✅ Font size
                                    fontWeight: "400",
                                    textAlign: "left",
                                  }}
                                >
                                  <tr>
                                    <th className="ps-2">LOCATION</th>
                                    <th className="ps-2">AMOUNT</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {viewStopDetails.fast_tag_cost?.map(
                                    (row, index1) => (
                                      <tr
                                        key={row.id}
                                        style={{
                                          height: "60px",
                                          position: "relative",
                                          overflow: "visible",
                                        }}
                                      >
                                        <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                          {row.location ?? ""}
                                        </td>

                                        <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                          {row.amount ?? ""}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}

                      {selectedTab === "Other Cost" && (
                        <>
                          <div style={{ overflowY: "visible" }}>
                            <div className="mt-2 sticky-table-wrapper ">
                              <table
                                className="stop-table"
                                border="1"
                                cellPadding="10"
                                style={{
                                  borderCollapse: "collapse",
                                  width: "100%",
                                  border: "1px solid #EBEBEB",
                                }}
                              >
                                <thead
                                  style={{
                                    height: "48px",
                                    /*  backgroundColor: "#F2F2F2", // ✅ Green background */
                                    color: "#8790A1", // ✅ White text
                                    fontSize: "11px", // ✅ Font size
                                    fontWeight: "400",
                                    textAlign: "left",
                                  }}
                                >
                                  <tr>
                                    <th className="ps-2">DESCRIPTION</th>
                                    <th className="ps-2">COST</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {viewStopDetails.other_cost?.map(
                                    (row, index1) => (
                                      <tr
                                        key={row.id}
                                        style={{
                                          height: "60px",
                                          position: "relative",
                                          overflow: "visible",
                                        }}
                                      >
                                        <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                          {row.description ?? ""}
                                        </td>

                                        <td className="px-2 py-1 fs-14 fw-400 textFontColor">
                                          {row.cost ?? ""}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="m-2 bg-white rounded-4 p-3">
                <p className="fs-16 fw-600" style={{ textAlign: "start" }}>
                  Attachment
                </p>
                <div className="row gap-2">
                  {(viewStopDetails?.attachments || []).map((file, index) => (
                    <div
                      key={index}
                      className="col-12 col-md-4 col-lg-3 rounded-4 p-2 d-flex align-items-center justify-content-between gap-3 my-2"
                      style={{ backgroundColor: "#F8F8F8" }}
                    >
                      <div className="d-flex align-items-center justify-content-start gap-2">
                        <img
                          src={attachment}
                          alt="pdf"
                          style={{ width: "32px", height: "32px" }}
                        />
                        <div className="d-flex flex-column">
                          <p className="m-0 fs-13 fw-500">
                            {file?.file_name || "-"}
                          </p>
                          <p className="m-0 fs-12 fw-400">
                            {file?.file_size || "0 "} KB
                          </p>
                        </div>{" "}
                      </div>
                      {file.file_path && (
                        <div
                          className="cursor-pointer"
                          onClick={() => {
                            downloadFile(
                              file.file_path,
                              file.file_path.split("/").pop()
                            );
                          }}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "100px",
                          }}
                        >
                          <img
                            src={downloadIc}
                            alt="download"
                            style={{
                              width: "12.8px",
                              height: "12px",
                              top: "10px",
                              left: "9.6px",
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </>
  );
};
